import type { AppSelector } from 'app/store'
import getDataSelector from 'core/utils/getDataSelector'
import { createSharedSelector } from 'core/utils/selectorHelpers'
import type { OpenStackMachineTemplate } from 'k8s/components/kaapi/kubeadm-control-plane/model'
import DataKeys from 'k8s/DataKeys'

export const kaapiOpenStackMachineTemplateSelector: AppSelector<any[]> = createSharedSelector(
  getDataSelector<DataKeys.KaapiOpenStackMachineTemplates>(DataKeys.KaapiOpenStackMachineTemplates),
  (kaapiOpenStackMachineTemplates): any[] => {
    return kaapiOpenStackMachineTemplates.map((kaapiOpenStackMachineTemplate) => {
      return kaapiOpenStackMachineTemplate
    })
  },
)

// Memoized name→template map: O(1) lookup vs O(m) linear scan per KCP.
// Rebuilt only when the templates array reference changes.
export const openStackMachineTemplatesByNameSelector = createSharedSelector(
  kaapiOpenStackMachineTemplateSelector,
  (templates): Map<string, OpenStackMachineTemplate> =>
    new Map(templates?.flatMap((t) => (t?.metadata?.name ? [[t.metadata.name, t]] : [])) ?? []),
)
